<template>
  <img
    :data-id="imageRef"
    :src="imgSrc"
    :alt="alt"
    :title="alt"
    :class="{rounded: rounded, 'bg': showBg}"
    :id="`js-img-${_uid}`"
    ref="image"
    @click="$emit('click')"
  />
</template>

<script>
import filesApi from "@/api/files";
require("intersection-observer");

export default {
  name: "ImageLoader",
  props: {
    image: {
      type: [Object, String],
      default: () => {}
    },
    alt: String,
    rounded: {
      type: Boolean,
      default: false
    },
    imageId: {
      type: [String, Number],
      default: null
    }
  },

  mounted() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0
    };
    if (this.$refs.image) {
      const observer = new IntersectionObserver(this.ioCallback, options);

      observer.observe(this.$refs.image);
    }
  },

  methods: {
    ioCallback(entries, observer) {
      const entryToCheck = entries[0];
      if (
        entryToCheck.isIntersecting &&
        entryToCheck.target.dataset.loaded != "true"
      ) {
        // check to see if we have this image loaded already
        this.$store
          .dispatch("files/getImageFromStore", entryToCheck.target.dataset.id)
          .then(resp => {
            entryToCheck.target.src = resp[0].src;
            entryToCheck.target.dataset.loaded = "true";
          })
          .catch(err => {
            this.getFile(entryToCheck.target.dataset.id);
            entryToCheck.target.dataset.loaded = "true";
          });
      }
    },
    getFile(fileId) {
      const vm = this;
      try {
        filesApi
          .read(fileId)
          .then(file => {
            filesApi
              .readLink(file.link)
              .then(response => {
                vm.setFileData(response.data, fileId);
                return Promise.resolve();
              })
              .catch(err => {
                vm.loading = false;
                return Promise.reject();
              });
          })
          .catch(err => {
            vm.loading = false;
            return Promise.reject();
          });
      } catch (err) {
        this.loading = false;
        return Promise.reject();
      }
    },

    setFileData(blob, fileId) {
      try {
        this.loading = false;
        const vm = this;
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function() {
          //once we have the data, put in store
          vm.$store
            .dispatch("files/addImageToStore", {
              id: fileId,
              base64data: reader.result
            })
            .then(resp => {
              const base64data = reader.result;
              vm.imgSrc = base64data;
              vm.loading = false;
              vm.showBg = false;
            });
        };
      } catch (err) {
        console.log("error", err);
      }
    }
  },
  data() {
    return {
      imgSrc: "/assets/event-thumb.svg",
      showBg: true
    };
  },
  computed: {
    imageRef() {
      if (!this.image && !this.imageId) {
        return "";
      }

      return this.imageId ? this.imageId : this.image.id;
    }
  },
  watch: {
    imageId(newValue, oldValue) {
      this.getFile(newValue);
    }
  },
};
</script>

<style scoped>
.bg {
  background: #e8edee;
}
.rounded {
  border-radius: 8px;
}

img {
  max-width: 100%;
}
</style>
